/**
 * <giini-kinetic> reveals child .g-kinetic__word spans when the element
 * scrolls into view, by adding the .is-inview class once.
 * Respects prefers-reduced-motion (reveals immediately).
 */
class GiiniKinetic extends HTMLElement {
  #observer = null;

  connectedCallback() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      this.classList.add('is-inview');
      return;
    }

    this.#observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (!entry.isIntersecting) continue;
          this.classList.add('is-inview');
          this.#observer?.disconnect();
        }
      },
      { threshold: 0.2 }
    );
    this.#observer.observe(this);
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
  }
}

if (!customElements.get('giini-kinetic')) {
  customElements.define('giini-kinetic', GiiniKinetic);
}
